import { Component, Input, OnChanges } from '@angular/core';

import { Transaction } from 'store/transaction/models';
import { Cloudinary } from 'core/services';

@Component({
    selector: 'xm-current-cycle-banner',
    styleUrls: ['./current-cycle-banner.scss'],
    templateUrl: './current-cycle-banner.html',
    standalone: false
})
export class CurrentCycleBanner implements OnChanges {
    @Input() public transaction: Transaction;
    @Input() public pageData: CmsCurrentCycle;
    @Input() public isLoading: boolean;

    public imageOptions: MediaImageOptions;

    public ngOnChanges(): void {
        if (this.transaction && this.pageData) {
            this.pageData.costHeader = this.pageData.costHeader.replace('[DATE]', this.transaction.title);
            this.imageOptions = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.image)
            };
        }
    }
}
